import React, { useMemo } from 'react'

import AssignToModalView from 'components/AssignToModal/AssignToModal'
import { useBulkAssignImportRequests } from 'services/import-requests/hooks/useBulkAssignImportRequests'
import { useBulkUnassignImportRequests } from 'services/import-requests/hooks/useBulkUnassignImportRequests'
import { useGetAssignableAssigneesForImportRequest } from 'services/import-requests/hooks/useGetAssignableAssigneesForImportRequest'
import { useGetUserInfo } from 'services/user/hooks/useGetUserInfo'

interface ImportRequestAssignToModalProps {
  requestId: string
  open: boolean
  onClose: () => void
  assignedTo?: string
}

export const ImportRequestAssignToModal: React.FC<ImportRequestAssignToModalProps> = ({
  requestId,
  open,
  onClose,
  assignedTo
}) => {
  const { data: actingUser } = useGetUserInfo()
  const assignableAssigneesQuery = useGetAssignableAssigneesForImportRequest(requestId)

  // The hooks already surface success/error toasts and invalidate the import-request queries.
  const bulkAssignMutation = useBulkAssignImportRequests({ onSuccess: onClose })
  const bulkUnassignMutation = useBulkUnassignImportRequests({ onSuccess: onClose })

  const options = useMemo(
    () => assignableAssigneesQuery.data?.data.map(item => ({ label: item.email, value: item._id })) ?? [],
    [assignableAssigneesQuery.data]
  )

  return (
    <AssignToModalView
      open={open}
      onClose={onClose}
      assignedTo={assignedTo}
      options={options}
      isLoadingOptions={assignableAssigneesQuery.isLoading}
      isError={assignableAssigneesQuery.isError}
      isSubmitting={bulkAssignMutation.isPending || bulkUnassignMutation.isPending}
      onAssign={(assigneeId, reviewConfirmed) =>
        bulkAssignMutation.mutate({ requestIds: [requestId], assigneeId, reviewConfirmed })
      }
      onUnassign={() => bulkUnassignMutation.mutate({ requestIds: [requestId] })}
      actingUserId={actingUser?._id}
    />
  )
}

export default ImportRequestAssignToModal
